export default class RenderConstants {
  public static readonly SCORE_TRESHOLD = 0.7;
  public static readonly SCALE_FACTOR_EASE = 0.4;
  public static readonly BASE_SIMILARITY_THRESHOLD = 0.8;
}
